import axios from '../axios'

let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}
/*
 * 文件管理
 */

// 删除 ids:文件表的Ids(多个Id用,分隔)
export const batchDelete = (data) => {
  return axios({
    url: '/mAttach/delete',
    method: 'post',
    data
  })
}
// 文件列表
export const list = (data) => {
  return axios({
    url: '/mAttach/list',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}


// 下载 attachId 附件表的Id
export const download = (data) => {
  return axios({
    url: '/mAttach/download',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}
/**
 *  获取文件配置
 * @param data
 * @returns {*|Promise|Promise<unknown>}
 */
export const getFileConfig = (data) => {
  return axios({
    url: '/mAttachConfig/list',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/attach.js